import { createSelector } from 'reselect';

import { countDirectTrips } from '../utils';
import { selectFilteredTrips } from './trips';

const selectDirectOnlyTripData = createSelector(
    selectFilteredTrips,
    countDirectTrips,
);

export {
    selectDirectOnlyTripData,
};
